export const toSampleId = ({ x, y }: { x: number; y: number }): string =>
  `${x}|${y}`;

export const toColumnId = ({ index }: { index: number }): string =>
  `column:${index}`;
